export const CREATOR_PROGRAM_SUBJECT = "Creator Program"

export const CUSTOM_BUILD_SUBJECT = "Custom Build"

export const CONTACT_SUBJECTS = [
  "General Inquiry",
  "Technical Support",
  "Product Question",
  CREATOR_PROGRAM_SUBJECT,
  "Partnership",
  CUSTOM_BUILD_SUBJECT,
  "Feedback",
  "Other",
] as const

export type ContactSubject = (typeof CONTACT_SUBJECTS)[number]

export function getContactSubjectFromSearchParam(value: string | null): ContactSubject | "" {
  if (!value) return ""
  return CONTACT_SUBJECTS.includes(value as ContactSubject) ? (value as ContactSubject) : ""
}
